import {Box, Paper, Typography} from '@mui/material';
import {Job} from '@cp/model';

interface JobDetailDialogLogsProps {
  job: Job;
}

export default function JobDetailDialogLogs({job}: JobDetailDialogLogsProps) {
  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom sx={{fontWeight: 600}}>
        Messages ({job.messages?.length || 0} entries)
      </Typography>
      <Paper sx={{maxHeight: 300, overflow: 'auto', bgcolor: 'grey.50'}}>
        <Box sx={{p: 2}}>
          {!job.messages || job.messages.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No messages available
            </Typography>
          ) : (
            <Box sx={{fontFamily: 'monospace'}}>
              {job.messages.map((message, index) => (
                <Typography
                  key={`JobDetailDialogLogs-Typography-${message}`}
                  variant="body2"
                  sx={{
                    mb: 0.5,
                    fontSize: '0.875rem',
                    lineHeight: 1.4,
                  }}
                >
                  [{index + 1}] {message}
                </Typography>
              ))}
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
}
